{% block sw_cms_section_action_select %}
    {% parent %}

    {% block sw_cms_section_action_block_rules_label %}
        <div
            v-if="hasRulesOnAllBlocks"
            class="sw-cms-section__action sw-cms-section__block-rules-label"
        >
            <mt-icon
                v-tooltip="rulesOnAllBlocksTooltip"
                name="solid-question-circle"
                size="20"
            />
        </div>
    {% endblock %}

    {% block sw_cms_section_action_scroll_navigation_label %}
        <div
            v-if="scrollNavigation?.active"
            class="sw-cms-section__action sw-cms-section__scroll-navigation-label"
        >
            <mt-icon
                v-tooltip="scrollNavigationPointTooltip"
                name="regular-tag"
                size="20">
            </mt-icon>
        </div>
    {% endblock %}
{% endblock %}
